import { render, staticRenderFns } from "./DraftPay.vue?vue&type=template&id=10812f5e&scoped=true&"
import script from "./DraftPay.vue?vue&type=script&lang=js&"
export * from "./DraftPay.vue?vue&type=script&lang=js&"
import style0 from "./DraftPay.vue?vue&type=style&index=0&id=10812f5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10812f5e",
  null
  
)

export default component.exports